import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Cart Header',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCartContainer', rule: 'ExactlyOne'}],
    descendants: [{is: 'CommerceCartCloseLink', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          position: 'relative',
          display: 'flex',
          paddingTop: px(16),
          paddingBottom: px(16),
          paddingLeft: px(24),
          paddingRight: px(24),
          justifyContent: 'space-between',
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: 'auto',
          borderBottomWidth: px(1),
          borderBottomStyle: 'solid',
          borderBottomColor: createRgbaColor('e6e6e6'),
          alignItems: 'center',
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
